import React, { Fragment } from 'react';

function QuestionShortAnswer({ onChange, questionId = '', hasInput = true, label = '', value, autoFocus = true }) {
  return (
    <Fragment>
      {label && (
        <label htmlFor={'input-' + questionId} className="form__text-label">
          {label}
        </label>
      )}
      {hasInput && (
        <input
          id={'input-' + questionId}
          type="text"
          onChange={onChange}
          value={value || ''}
          autoFocus={autoFocus}
        />
      )}
    </Fragment>
  );
}

export default QuestionShortAnswer;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionShortAnswer.js